import styled from '@emotion/styled';

import { Grid, Card, CardHeader, CardContent, CardActions, Button, Typography, Avatar } from '@mui/material';

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from '../../../utils/utilities/CardComponents';

import ReportRoundedIcon from '@mui/icons-material/ReportRounded';
import KeyOffRoundedIcon from '@mui/icons-material/KeyOffRounded';
import KeyRoundedIcon from '@mui/icons-material/KeyRounded';

import axios from '../../../axios';

// use pageData context
import { usePageData } from '../../../contexts/PageData';

// useMutation hook
import { useMutation, useQueryClient } from '@tanstack/react-query';

//snackbar
import useSnackbarStore from '../../../store/snackbar';

// authservice
import AuthService from '../../../store/auth/AuthService';


const SecurityTab = () => {
  const showSnackbar = useSnackbarStore((state) => state.showSnackbar);
  const queryClient = useQueryClient();

  const { data = {} } = usePageData();

  console.log(data, "data");

  const { mutate: emailLinkMutate, isPending } = useMutation({
    mutationFn: AuthService.emailLink,
    onSuccess: () => {
      showSnackbar('Email sent successfully!', 'success');
    },
    onError: (e) => {
      showSnackbar('Failed to send email!', 'error');
    }
  })


  const { mutate: activateMutate, isPending: isActivating } = useMutation({
    mutationFn: AuthService.activateAccount,
    onSuccess: (data) => {
      let { action } = data
      showSnackbar(`User was ${action}d successfully!`, 'success');
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
    onError: (e) => {
      showSnackbar(`Action Failed!`, 'error');
    }
  })


  const roleBlock = [
    {header: "Role", info: data.role},
  ];

  const permissionsBlock = [
    {header: "Read", info: data.permissions.filter(el => el.action === "read").map(el => el.subject).join(", "), align: "flex-start"},
    {header: "Manage", info: data.permissions.filter(el => el.action === "manage").map(el => el.subject).join(", "), align: "flex-start"},
  ]

  const activateText = data.is_active ? "Deactivate User" : "Activate User";
  const activityColor = data.is_active ? "error" : "success";
  const activeParagraph = data.is_active ? "The user will lose access to the system after they are deactivated." : "The user will gain access to the system after they are activated.";

  return (
    <Grid container spacing={3}>
      <Grid size={{xs: 12, md: 4}}>
        <Card variant='outlined'>
          <CardHeader title="User Permissions" />
          <CardContent>
            <CardBlockContainer>
            <CardBlockHeader>Role</CardBlockHeader>
              {roleBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}
            <CardSpacer />
            <CardBlockHeader>Permissions</CardBlockHeader>
              {permissionsBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}
            </CardBlockContainer>
          </CardContent>
        </Card>
      </Grid>
      <Grid size={{xs: 12, md: 4}}>
      <Card variant='outlined'>
        <CardHeader title="Account Setup" />

        <CardContent>
        <Typography variant="body1" sx={{ color: 'text.secondary', fontSize: "1.6rem" }}>
        Use the buttons below to send an email to the user with a link to setup their account or reset their password
        </Typography>
        </CardContent>

        <CardActions>
          <Button size="small" loading={isPending} onClick={() => emailLinkMutate({user_id: data.user_id, action: "setup"})}>
            Setup Account
          </Button>
          <Button size="small" loading={isPending} onClick={() => emailLinkMutate({user_id: data.user_id, action: "reset"})}>
            Reset Password
          </Button>
        </CardActions>
      </Card>
      </Grid>

      <Grid size={{xs: 12, md: 4}}>
        
      </Grid>

      <Grid size={{xs: 12, md: 4}}>
        <Card variant='outlined'>
          <CardHeader title={activateText} action={<ReportRoundedIcon fontSize='large' color="error" />} />
          <CardContent>
            <Typography variant="body1" sx={{ color: 'text.secondary', fontSize: "1.6rem" }}>
            {activeParagraph}
            </Typography>
          </CardContent>
          <CardActions>
            <Button startIcon={<KeyOffRoundedIcon />} fullWidth variant='contained' color={activityColor} loading={isActivating} onClick={() => activateMutate({user_id: data.user_id, action: data.is_active ? "deactivate" : "activate"})}>
              {activateText}
            </Button>
          </CardActions>
        </Card>
      </Grid>
      
    </Grid>
  );

};

export default SecurityTab;